import { useTranslation } from 'react-i18next';
import {
  Box,
  Center,
  Text,
  Image,
  Stack,
  useBreakpointValue
} from '@chakra-ui/react';
import footerPattern from '../img/Stroke PT4@2x.png'; 

export default function Footer() {
  const orgColor = "#ec562c";
  const bluColor = "#2f4280";
  const { t } = useTranslation();

  const patternHeight = useBreakpointValue({ base: "80px", md: "100px" });

  return (
    <Box position="relative" bg={bluColor} color={'#fff'}  pb={patternHeight} overflow="hidden">
      {/* Footer Content */}
      <Stack spacing={2} align="center" textAlign="center">
        <Text fontSize={{ base: "sm", md: "md" }}  letterSpacing="wide">
          {t('footer.rights')}
        </Text>
      </Stack>

      {/* Pattern at the bottom */}
      <Box
        position="absolute"
        bottom="0"
        left="0"
        w="100%"
        h={patternHeight}
        zIndex={0}
      >
        <Image
          src={footerPattern}
          alt="Footer Pattern"
          width="100%"
          height="100%"
          objectFit="cover"
        />
      </Box>
    </Box>
  );
}
